import type { PropsWithChildren } from 'react';
import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';

export const FormWrap = ({ children }: PropsWithChildren) => {
  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        margin: 0 15%;
        min-width: 300px;
        max-width: 400px;
        @media screen and (max-width: ${breakpoints.small.max}px) {
          width: 90%;
          margin: 0 5%;
        }
      `}
    >
      <div
        css={css`
          display: flex;
          flex-direction: column;
          width: 100%;
        `}
      >
        {children}
      </div>
    </div>
  );
};
